import { IChangeListItemImageProps } from "./ChangeListItemTypes"

import { Text, Flex, Image } from "@chakra-ui/react"

const ChangeListItemImage: React.FC<IChangeListItemImageProps> = ({ title, imageUrl }) => {
  return (
    <>
      <Text mb={"8px"} fontSize="base">
          {title}
      </Text>
      <Flex padding={"16px"} borderRadius={"10px"} align={"center"} justifyContent="center" bgColor={"#fff"}>
          <Image src={imageUrl} />
      </Flex>
    </>
  )
}

export default ChangeListItemImage